export const PARTS_LIGHT_SOURCES_MODALS_EVENT = `modals:parts:light-sources`;

export const SEARCH_LIGHT_SOURCE_MODAL_EVENT = `${PARTS_LIGHT_SOURCES_MODALS_EVENT}:search-light-source`;
export const SEARCH_LIGHT_SOURCE_MODAL_EVENT_OPEN = `${SEARCH_LIGHT_SOURCE_MODAL_EVENT}:open`;
export const SEARCH_LIGHT_SOURCE_MODAL_EVENT_CLOSE = `${SEARCH_LIGHT_SOURCE_MODAL_EVENT_OPEN}:close`;
